import { render, staticRenderFns } from "./OrderDetailGroup.vue?vue&type=template&id=a9856d14&scoped=true&"
import script from "./OrderDetailGroup.vue?vue&type=script&lang=js&"
export * from "./OrderDetailGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9856d14",
  null
  
)

export default component.exports